import "antd/dist/antd.min.css";
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import * as firebase from 'firebase';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import { store } from './redux/store';
import { initializeIcons } from '@fluentui/react/lib/Icons';
import { loadTheme } from 'office-ui-fabric-react';
import theme from './theme/theme.json';
import extendsNumber from './extensions/number';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { persistQueryClient } from '@tanstack/react-query-persist-client'
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister'
import { QUERY_TIMES_MS } from "./config/queryConfig";

const queryClient = new QueryClient();
const persister = createSyncStoragePersister({ storage: window.localStorage })

persistQueryClient({
  queryClient,
  persister,
  maxAge: QUERY_TIMES_MS.MAX_AGE,
});

extendsNumber();
initializeIcons('https://static2.sharepointonline.com/files/fabric/assets/icons/');

firebase.initializeApp({
  apiKey: 'AIzaSyCC7gVI5rvobkmJ3BqP83NXKgGGWHqOuc4',
  applicationId: 'certificacion-de-horas',
  projectId: 'certificacion-de-horas',
  authDomain: 'certificacion-de-horas.firebaseapp.com',
});

loadTheme({
  palette: theme,
});

// 👇 envolver con ambos providers
ReactDOM.render(
  <Provider store={store}>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </Provider>,
  document.getElementById('root')
);

serviceWorker.unregister();
